import { useSearchParams } from 'react-router-dom';
import { useQuery, useQueryClient } from 'react-query';
import { useState } from 'react';
import { useContext } from 'react';

import AuthContext from '../store/auth-context';

import DashboardHeader from '../components/mainDashboard/DashboardHeader';
import Loader from '../components/ui/Loader';
import ReactECharts from 'echarts-for-react';
import ResultsTable from '../components/adminDashboard/ResultsTable';

import DashboardReportContainer from '../components/adminDashboard/DashboardReportContainer';


import './ReportsPage.scss';
import { AccessibilityContext } from '../store/accesibility-context';
import { getStatsReport } from '../api/hospitalsAPI';
import { getTimeReviewing } from '../api/superAPI';
const ReportsPage = ({
	status,
	// id,
	// type,
	title,
    value,
	// role
}) => {
	const statsQuery = useQuery({
		queryKey:['stats-for-report'],
		queryFn: getStatsReport,
		retry: false,
		staleTime: 3000000 //5 minutes to refetch
	})
	const completedQuery = useQuery({
		queryKey:['studies-completed'],
		queryFn: getTimeReviewing,
		retry: false,
		staleTime: 3000000 //5 minutes to refetch
	})
	
	if (statsQuery.isLoading || completedQuery.isLoading) {
		return <Loader/>;
    }
	
    if (statsQuery.error || completedQuery.error) {
		return <div>Error: {error.message}</div>;
    }
	const {status_stats:stats, performances	} = statsQuery.data.data.stats;
	const titlesNames = {
		underReview: 'Under Review',
		completed: 'Completed',
		submittedForAnalysis: 'Submitted For Analysis',
		reviewRequested: 'Review Requested',
		missingProtocolInfo: 'Missing Protocol Info'
	}
	
	// const onPageChange = (targetPageNumber) => {
		// 	setPageNumber(targetPageNumber);
		// 	queryClient.invalidateQueries('studies');
		// };
		// console.log()
		const totalStudies = statsQuery.data.data.stats.status_stats[0].completed/12;
		
	const {January, February, March, April, May, June, July, August, September, October, November, December}= completedQuery.data.data;
	const option = {
			xAxis: {
			  type: 'category',
			  data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
			},
			yAxis: {
			  type: 'value',
			  show: false
			},
			series: [
			  {
				data: [
				  {
					value: January.studies,
					itemStyle: {
						color: '#DCF1EE'
					}
				  },
				  {
					value: February.studies,
					itemStyle: {
					  color: '#DCF1EE'
					}
				  },
				  {
					value: March.studies,
					itemStyle: {
					  color: '#DCF1EE'
					}
				  },
				  {
					value: April.studies,
					itemStyle: {
					  color: '#DCF1EE'
					}
				  },
				  {
					value: May.studies,
					itemStyle: {
					  color: '#DCF1EE'
					}
				  },
				  {
					value: June.studies,
					itemStyle: {
					  color: '#74C9BB'
					}
				  },
				  {
					value: July.studies,
					itemStyle: {
					  color: '#DCF1EE'
					}
				  },
				  {
					value: August.studies,
					itemStyle: {
					  color: '#DCF1EE'
					}
				  },
				  {
					value: September.studies,
					itemStyle: {
					  color: '#DCF1EE'
					}
				  },
				  {
					value: October.studies,
					itemStyle: {
					  color: '#DCF1EE'
					}
				  },
				  {
					value: November.studies,
					itemStyle: {
					  color: '#DCF1EE'
					}
				  },
				  {
					value: December.studies,
					itemStyle: {
					  color: '#DCF1EE'
					}
				  },
				],
				type: 'bar',
				label: {
					show: true,
					position: 'top', 
					formatter: '{c}',  
				  },
				  itemStyle: {
					color: '#4CAF50', 
				  },
			  },
			  
			]
		};
	const timeAvrg = Object.values(completedQuery.data.data).reduce((total, actual)=>total+=actual.time, 0)/12;
	const option2 = {
			xAxis: {
			  type: 'category',
			  boundaryGap: false,
			  data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
			},
			yAxis: {
			  type: 'value'
			},
			series: [
			  {
				data: [
					January.studies ? January.time / January.studies : 0,
					February.studies ? February.time / February.studies : 0,
					March.studies ? March.time / March.studies : 0,
					April.studies ? April.time / April.studies : 0,
					May.studies ? May.time / May.studies : 0,
					June.studies ? June.time / June.studies : 0,
					July.studies ? July.time / July.studies : 0,
					August.studies ? August.time / August.studies : 0,
					September.studies ? September.time / September.studies : 0,
					October.studies ? October.time / October.studies : 0,
					November.studies ? November.time / November.studies : 0,
					December.studies ? December.time / December.studies : 0
				  ],
				type: 'line',
				areaStyle: {},
				itemStyle:{
					color: '#F5BE5026'
				}
			  }
			]
		  };
	
	return (
		<div className='dashboard-general-wrapper'>
			<DashboardHeader />
			<div className='dashboard-content-container'>
				<div className='content-header'>
					<div className='content-title'>
						<h2>Reports</h2>
					</div>	
				</div> 
			</div>
				{/* TODO Paginator should be a single component */}
				{/* <div className='pagination'>
					<Resultspages
						currentPage={pageNumber}
						pageSize={itemsPerPage}
						totalElements={totalStudies}
					/>

					<Pagination
						currentPage={pageNumber}
						sizeNumber={itemsPerPage}
						totalNumber={totalStudies}
						changePage={onPageChange}
					/>
				</div> */}
				<div className='dashboard-states-container'>
					<div className='stats-container'>
						{stats.map(item => {
						const [title, value] = Object.entries(item)[0]
						return <DashboardReportContainer
							title={titlesNames[title]}
							value={value}
							
							/>
						})}
					</div>
				</div>
				<div className='graphics-container'>
					<div className='boxes-graphics'>
						<h3>Finished Studies</h3>
						<p>Avr. per month</p>
						<h3>{totalStudies}</h3>
						<ReactECharts option={option}
						style={{height: '300px', width: '100%'}}/>
					</div>
					<div className='boxes-graphics'>
						<h3>Time Management</h3>
						<p>Avr. per month</p>
						<h3>{timeAvrg.toFixed(2)}</h3>
						<ReactECharts option={option2}/>
					</div>
				</div>

				<div className='performance-container'>
					<div className='boxes-stats'>
						<div className='stats-title'>
							<h3>P.I Performance</h3>
						</div>
						<div>
						<ResultsTable data={performances[1]}/>
						</div>
					</div>
					<div className='boxes-stats'>
						<div className='stats-title'>
							<h3>Q.A Performance</h3>
						</div>
						<ResultsTable data={performances[0]}/>
					</div>
				</div>
			
			
			
			
		</div>
	);
};
export default ReportsPage;
